import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AmparosComponent} from '../amparos.component'
//Services
import {ProtectionService} from 'src/app/core/services/parameters/protection.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearAmparoModal implements OnInit {

  newProtectionForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<AmparosComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private protectionService: ProtectionService
  ) {
  }

  ngOnInit(): void {
    this.newProtectionForm = this.fb.group({
      protection: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newProtectionForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newProtectionForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.protection
      }
      this.protectionService.createProtection(data).subscribe(_res => {
        this.alert.setNotice('Amparo creada correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear el amparo', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
